import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ApiUserManager } from '../../enums/api-user-manager.enum';
import { GenericConstants } from '../../enums/generic-constants.enum';
import { UserBasicResponse } from '../../models/admin-user/user-basic-response';

@Injectable({
  providedIn: 'root'
})
export class AccountSettingsService {

  constructor(private http: HttpClient) { }

  getUserInfo(){
    let url = environment.baseUrl + ApiUserManager.USER_BASIC_INFO;
    let headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: localStorage.getItem(GenericConstants.STORAGE_ACCESS_TOKEN),
    });
    return this.http.get(url, { headers: headers });
  }

  updateUserInfo(userInfo: UserBasicResponse) {
    let url =
      environment.baseUrl +
      ApiUserManager.UPDATE_USER_BASIC_INFO;
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem(
        GenericConstants.STORAGE_ACCESS_TOKEN
      ),
    });
    return this.http.put(url, JSON.stringify(userInfo), {
      headers: headers,
    });
  }

  updatePassword(param: { old_password: string; new_password: string }) {
    let url =
      environment.baseUrl +
      ApiUserManager.UPDATE_USER_PASSWORD;
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem(
        GenericConstants.STORAGE_ACCESS_TOKEN
      ),
    });
    return this.http.put(url, JSON.stringify(param), {
      headers: headers,
    });
  }

  resendVelidationEmail(){
    let url =
      environment.baseUrl +
      ApiUserManager.RESEND_VALIDATION_EMAIL;
      let headers = new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: localStorage.getItem(GenericConstants.STORAGE_ACCESS_TOKEN),
      });
    return this.http.post(url, "", {
      headers: headers,
    });
  }

  getPlans(){
    let url = environment.baseUrl + ApiUserManager.USER_PLANS;
    let headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: localStorage.getItem(GenericConstants.STORAGE_ACCESS_TOKEN),
    });
    return this.http.get(url, { headers: headers });
  }


}
